import { useMutation } from '@tanstack/react-query'
import { putWalletDescription } from 'services/WalletsService'

export const usePutWalletDescriptionMutation = () => {
  return useMutation({ mutationFn: putWalletDescription })
}
